export default {
      id: "arrow_right-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#arrow_right",
      toString: function () {
        return this.url;
      }
    }